import { ALL_APPS, ALL_VIEWS } from 'constants/appConstants';
import PermissionsRouteWrapper from 'views/pages/components/PermissionsRouteWrapper';
import Loadable from 'ui-component/Loadable';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import FullHeightMainCardWrapper from 'layout/MainLayout/FullHeightMainCardWrapper';
import { ORG_PREFERENCES_TABS } from 'views/org/OrgPreferences';

const Suppliers = Loadable(lazy(() => import('views/suppliers/Suppliers')));
const PurchaseRules = Loadable(
  lazy(() => import('views/suppliers/PurchaseRules'))
);
const Supplier = Loadable(lazy(() => import('views/suppliers/Supplier')));

export const SuppliersRoutes = [
  {
    path: `${ALL_APPS.SUPPLIERS.path}`,
    element: (
      <FullHeightMainCardWrapper>
        <PermissionsRouteWrapper
          permissionScope={{ app: ALL_APPS.SUPPLIERS.id }}
        >
          <Suppliers />
        </PermissionsRouteWrapper>
      </FullHeightMainCardWrapper>
    ),
  },
  {
    path: `${ALL_APPS.SUPPLIERS.views?.SUPPLIERS?.path}`,
    element: (
      <FullHeightMainCardWrapper>
        <PermissionsRouteWrapper
          permissionScope={{ app: ALL_APPS.SUPPLIERS.id }}
        >
          <Navigate to={ALL_APPS.SUPPLIERS.path ?? ''} replace />
        </PermissionsRouteWrapper>
      </FullHeightMainCardWrapper>
    ),
  },
  {
    path: `${ALL_VIEWS.SUPPLIERS.path}/:supplierId`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APPS.SUPPLIERS.id,
        }}
      >
        <Supplier />
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: `${ALL_APPS.SUPPLIERS.views?.PURCHASE_RULES?.path}`,
    element: (
      <FullHeightMainCardWrapper>
        <PermissionsRouteWrapper
          permissionScope={{
            app: ALL_APPS.ORG_SETTINGS.id,
          }}
        >
          <Navigate
            to={`${ALL_APPS.ORG_SETTINGS.path}?tab=${ORG_PREFERENCES_TABS.PURCHASE_RULES}`}
            replace
          />
        </PermissionsRouteWrapper>
      </FullHeightMainCardWrapper>
    ),
  },
];
